export default "__VITE_ASSET__BPmrjOAw__"